import { CSSProperties } from 'react';
import { Colors, TypographyComponent, TypographyVariants } from '../Types';
import style from './Typography.module.scss';
type TypographyDefaultProps<E extends React.ElementType> = {
  component?: E;
  variant: TypographyVariants;
  color?: Colors;
};

// in this type we have a generic type (E) that points to "component" props type and 'Omit' exports all attributes
// of htmlTag "component" except keys of TypographyDefaultProps
type TypographyProps<E extends React.ElementType> = TypographyDefaultProps<E> & Omit<React.ComponentProps<E>, keyof TypographyDefaultProps<E>>;
const Typography = <E extends TypographyComponent,>({
  component,
  children,
  className,
  color,
  variant,
  ...rest
}: TypographyProps<E>) => {
  const Component = (component || 'span') as React.ElementType;
  return <Component className={style['typography-color'] + ' ' + style[`${variant}`] + ' ' + `${className ? className : ''}`
  // `${color ? style[`${color}`] : ''}`
  } style={{
    '--typo-color': `var(--${color})`
  } as CSSProperties} {...rest} data-sentry-element="Component" data-sentry-component="Typography" data-sentry-source-file="Typography.tsx">
      {children}
    </Component>;
};
export default Typography;